export const TREATMENT_SUMMARY_LOADED_SUCCESS = 'TREATMENT_SUMMARY_LOADED_SUCCESS';
export const TREATMENT_SUMMARY_LOADED_FAILED = 'TREATMENT_SUMMARY_LOADED_FAILED';
export const UNSEEN_TREATMENT_SUMMARY_COUNT_SUCCESS = 'UNSEEN_TREATMENT_SUMMARY_COUNT_SUCCESS';
export const UNSEEN_TREATMENT_SUMMARY_COUNT_FAILED = 'UNSEEN_TREATMENT_SUMMARY_COUNT_FAILED';
